import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
   selector: 'input-clear',
   templateUrl: './input-clear.component.html',
   styleUrls: []
})
export class InputClearComponent implements OnInit {
   @Input() Width: string = '300px';
   @Output() eventClick: EventEmitter<any> = new EventEmitter();
   
   constructor() {
   }
   
   ngOnInit() {
   }
   
   erase() {
      this.eventClick.emit();
   }
}
